"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccessToken {
    constructor(token, tokenType, expiresIn, scope, mfaRequred, user) {
        this.token = token;
        this.tokenType = tokenType;
        this.expires = expiresIn;
        this.scope = scope;
        this.mfaRequired = (mfaRequred === true);
        this.user = user;
    }
}
exports.default = AccessToken;
//# sourceMappingURL=access-token.js.map